import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DownloadArquivoComponent } from './download-arquivo.component';


@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: DownloadArquivoComponent}
  ])],
  exports: [RouterModule]
})
export class DownloadArquivoRoutingModule { }
